module.exports = __webpack_public_path__ + "img/P150T_weapon_92.dc3ac3ff.png";